import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { ContentItem } from '@/utils/contentService';

interface PlaylistPlayerModalProps {
  items: ContentItem[];
  onClose: () => void;
}

const PlaylistPlayerModal: React.FC<PlaylistPlayerModalProps> = ({ items, onClose }) => {
  const [indexAtual, setIndexAtual] = useState(0);
  const itemAtual = items[indexAtual];

  useEffect(() => {
    if (!items || items.length === 0) {
      onClose(); // Fecha se a playlist estiver vazia
    }
  }, [items, onClose]);

  const avancar = () => {
    if (indexAtual < items.length - 1) {
      setIndexAtual((prev) => prev + 1);
    } else {
      onClose();
    }
  };

  const renderPlayer = () => {
    if (itemAtual?.videoSrc) {
      return (
        <video
          src={itemAtual.videoSrc}
          className="w-full rounded"
          controls
          autoPlay
          onEnded={avancar}
        />
      );
    }

    if (itemAtual?.embedId) {
      return (
        <div className="relative pb-[56.25%] h-0 overflow-hidden rounded">
          <iframe
            src={itemAtual.embedId}
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
            allowFullScreen
            className="absolute top-0 left-0 w-full h-full"
            frameBorder="0"
            title={itemAtual.title || 'Vídeo incorporado'}
            onLoad={() => setTimeout(avancar, 30000)} // Avança automaticamente após 30s
          />
        </div>
      );
    }

    return (
      <div className="bg-[#222] text-white p-6 rounded text-center">
        <p>Este item não possui vídeo compatível.</p>
        <button
          onClick={avancar}
          className="mt-4 px-4 py-2 bg-rustico-brown rounded text-white"
        >
          Pular
        </button>
      </div>
    );
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/90 flex flex-col items-center justify-center p-4">
      <div className="relative w-full max-w-4xl">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 bg-red-600 hover:bg-red-700 text-white w-8 h-8 rounded-full flex items-center justify-center z-50"
        >
          <X size={18} />
        </button>

        {itemAtual ? renderPlayer() : null}

        {itemAtual && (
          <div className="mt-4 text-white text-center">
            <p>
              Reproduzindo {indexAtual + 1} de {items.length}:{' '}
              <strong>{itemAtual.title}</strong>
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PlaylistPlayerModal;
